/** Browse / catalog category normalization for Home + Product Catalog. */

export const SALMON_CATEGORY_CANONICAL = 'SMOKED SALMON';

export function sanitizeCategoryText(str) {
    return String(str || '')
        .replace(/\uFFFD/g, '')
        .replace(/[^\x00-\x7F]/g, '')
        .trim();
}

export function getCategoryFirstWord(label) {
    const cleaned = sanitizeCategoryText(label);
    if (!cleaned) return '';
    const match = cleaned.match(/^[\s\-]*([A-Za-z0-9]+)/);
    return match ? match[1].toLowerCase() : '';
}

/** True when a browse category label should roll up to SMOKED SALMON. */
export function isSalmonBrowseCategory(label) {
    const cleaned = sanitizeCategoryText(label);
    if (!cleaned) return false;
    if (getCategoryFirstWord(cleaned) === 'salmon') return true;
    return /\bsalmon\b/i.test(cleaned);
}

/**
 * Collapse salmon sub-categories (e.g. "Salmon …", "Sashimi-Grade Smoked Salmon Packs") into one.
 */
export function normalizeBrowseCategoryLabel(raw) {
    const cleaned = sanitizeCategoryText(raw);
    if (!cleaned) return 'Uncategorized';

    if (isSalmonBrowseCategory(cleaned)) {
        return SALMON_CATEGORY_CANONICAL;
    }

    return cleaned;
}

/**
 * Merge saved category order with present categories; dedupe after normalization.
 */
export function mergeBrowseCategoryOrder(savedOrder = [], present = []) {
    const normalizedPresent = Array.from(
        new Set((present || []).map((item) => normalizeBrowseCategoryLabel(item)).filter(Boolean))
    );

    const normalizedSaved = (Array.isArray(savedOrder) ? savedOrder : [])
        .map((item) => normalizeBrowseCategoryLabel(item))
        .filter(Boolean);

    const seen = new Set();
    const merged = [];

    for (const entry of normalizedSaved) {
        if (normalizedPresent.includes(entry) && !seen.has(entry)) {
            merged.push(entry);
            seen.add(entry);
        }
    }

    for (const entry of normalizedPresent) {
        if (!seen.has(entry)) {
            merged.push(entry);
            seen.add(entry);
        }
    }

    return merged;
}

const CHIP_LABEL_OVERRIDES = {
    'CHARCUTERIE': 'Charcuterie',
    'FRESH SAUSAGE (GLUTEN FREE)': 'Sausage',
    'Best Sellers': 'Best sellers',
    'Featured': 'Featured',
};

/** Shorter labels for non-brochure chips (specials, legacy categories). Brochure sections use exact names via customerDisplayCategoryUtils. */
export function formatCategoryChipLabel(categoryKey) {
    const key = sanitizeCategoryText(categoryKey);
    if (!key || key === 'All') return key;

    const override = CHIP_LABEL_OVERRIDES[key] || CHIP_LABEL_OVERRIDES[key.toUpperCase()];
    if (override) return override;

    if (key === key.toUpperCase() && /[A-Z]/.test(key)) {
        return key
            .toLowerCase()
            .split(/\s+/)
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    }

    return key;
}
